import React, { useState, useEffect } from "react";
import { Form, Input, Button, notification } from "antd";
import { auth } from "../../../../firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const PhoneVerificationPage = () => {
  const [form] = Form.useForm();
  const [verificationId, setVerificationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (!window.recaptchaVerifier) {
        console.log("Setting up RecaptchaVerifier...");
        window.recaptchaVerifier = new RecaptchaVerifier(
          auth,
          "recaptcha-container",
          {
            size: "invisible",
            callback: () => {
              console.log("recaptcha solved");
            },
          }
        );
        window.recaptchaVerifier.render();
      }
    } catch (err) {
      console.error("Recaptcha setup failed:", err);
    }
  }, []);

  const handleSendCode = async ({ phone }) => {
    setLoading(true);

    try {
      const appVerifier = window.recaptchaVerifier;

      const confirmation = await signInWithPhoneNumber(
        auth,
        phone,
        appVerifier
      );
      setVerificationId(confirmation);
      console.log("Verification ID set:", confirmation);
      api.success({ message: "Verification code sent!" });
    } catch (err) {
      console.error("Error during signInWithPhoneNumber:", err);
      let msg = "Something went wrong.";
      switch (err.code) {
        case "auth/invalid-phone-number":
          msg = "Invalid phone number format. Use +923001234567.";
          break;
        case "auth/too-many-requests":
          msg = "Too many requests. Try again later.";
          break;
        case "auth/argument-error":
          msg = "Missing/invalid arguments in signInWithPhoneNumber.";
          break;
        case "auth/invalid-app-credential":
          msg = "Invalid app credential.";
          break;
        default:
          msg = err.message || msg;
      }
      api.error({ message: msg });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async ({ code }) => {
    setLoading(true);
    try {
      if (!verificationId) throw new Error("No verification ID available");
      await verificationId.confirm(code);
      api.success({ message: "Phone verified!" });
      navigate("/landlord/dashboard");
    } catch (err) {
      console.error("Error verifying code:", err);
      api.error({ message: "Invalid code. Try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="recaptcha-container" />
      <div
        style={{
          maxWidth: 360,
          margin: "0 auto",
          paddingTop: 80,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {!verificationId ? (
          <Form layout="vertical" onFinish={handleSendCode} form={form}>
            <Form.Item
              name="phone"
              rules={[{ required: true, message: "Enter phone number" }]}
            >
              <Input placeholder="+92xxxxxxxxxx" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Send Code
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Form layout="vertical" onFinish={handleVerifyCode}>
            <Form.Item
              name="code"
              rules={[{ required: true, message: "Enter 6-digit code" }]}
            >
              <Input placeholder="Enter code" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block>
                Verify
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
      {contextHolder}
    </>
  );
};

export default PhoneVerificationPage;
